import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  notificationObservedDiv: {
    position: 'absolute',
    top: '201px',
    left: '24px',
  },
  notificationContainer: {
    position: 'fixed',
    bottom: '8px',
    left: '8px',
    right: '8px',
    backgroundColor: theme.evPalette.ocean[600],
    borderRadius: '4px',
    color: 'white',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexDirection: 'row',
    padding: '16px',
    zIndex: 9999,
    transform: 'unset',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    '@media(min-width: 640px)': {
      position: 'absolute',
      top: '201px',
      left: '24px',
      bottom: 'unset !important',
      maxWidth: '467px',
      '&.fixed': {
        position: 'fixed',
        top: '10px',
        left: '24px',
      },
    },
  },
  errorContainer: {
    backgroundColor: theme.evPalette.rose[100],
  },
  notificationBarHeader: {
    margin: 0,
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '27px',
  },
  closeButton: {
    padding: 0,
    minWidth: 'unset',
  },
  progressBar: {
    width: '95%',
    '@media(min-width: 640px)': {
      maxWidth: '350px',
    },
  },
  root: {
    margin: '8px',
    backgroundColor: 'white', // Background color of the bar track
  },
  bar: {
    backgroundColor: theme.evPalette.ocean[900], // Custom color for the progress bar
  },
  errorAlert: {
    backgroundColor: theme.evPalette.rose[100],
  },
  alertMsg: {
    padding: '3px 0',
  },
  alertCloseButton: {
    color: theme.evPalette.rose[900],
  },
  sticky: {
    '@media(min-width: 640px)': {
      top: '10px',
      left: '24px',
    },
  },
  errorAlertIcon: {
    padding: '3px 0',
    fontSize: '24px',
    marginRight: '8px',
    '& svg': { color: theme.evPalette.rose[900] },
  },
  notificationSuccessIcon: {
    color: '#89DC65',
    marginRight: '16px',
    verticalAlign: 'sub',
  },
}));
